import UILayout from '@components/layouts/ui';
import Title from '@components/Ui/Title';
import { useTranslation } from 'react-i18next';
import { listLoadSsr, ServicesState } from '@store/services';
import { AppDispatch, RootState } from '@store/types';
import withAuth from '@utils/withAuth';
import { Page } from '@pages/Type';
import withLayout from '@root/utils/withLayout';
import { useSelector } from 'react-redux';
import List from './List';
import LoadingList from './LoadingList';
import EmptyList from './EmptyList';
import withMassActions from './MassAction/withMassActions';
import ListMassActions from './ListMassActions';

// TODO: implement pagination...
// https://sergiodxa.com/articles/swr/pagination/
// TODO: implement service sort

const ServicesPage: Page = () => {
    const { t } = useTranslation('uiServicesMain');
    const services = useSelector<RootState, ServicesState>(
        (state) => state.services,
    );

    // TODO: implement load, and try static vs server side
    // const dispatch = useDispatch<AppDispatch>();

    /*
  useEffect(() => {
    if (!services.initalized) {
      // TODO: implement load, and try static vs server side
      dispatch(loadServices());
    }
  }, []);
  */

    if (services.isRequesting) {
        return (
            <>
                <Title title={t('title', 'Paslaugų valdymas')} />
                <LoadingList />
            </>
        );
    }

    if (services.error) {
        return <>Error: {services.error}</>;
    }

    if (Object.keys(services.data).length <= 0) {
        return (
            <>
                <Title title={t('title', 'Paslaugų valdymas')} />
                <EmptyList />
            </>
        );
    }

    return (
        <>
            <Title title={t('title', 'Paslaugų valdymas')}>
                {false && (
                    <div className="service-sort">
                        Rusiuoti pagal:
                        <div className="btn-group">
                            <button
                                type="button"
                                className="btn btn-link dropdown-toggle"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                Galiojimo laika
                            </button>
                            <div className="dropdown-menu dropdown-menu-right">
                                <button className="dropdown-item" type="button">
                                    Action
                                </button>
                                <button className="dropdown-item" type="button">
                                    Another action
                                </button>
                                <button className="dropdown-item" type="button">
                                    Something else here
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </Title>

            <ListMassActions />

            <List />
        </>
    );
};

// TODO: try static props load
export const getServerSideProps = withAuth(async ({ store }) => {
    if (
        !store.getState().services.isRequesting &&
        Object.keys(store.getState().services.data).length === 0
    ) {
        await (store.dispatch as AppDispatch)(listLoadSsr());
    }
    return { props: {} };
});

ServicesPage.displayName = 'uiServicesMain';

export default withLayout(UILayout, withMassActions(ServicesPage));
